import get from 'lodash/get';

export const getIsPermissionDialogOpen = state => state.pushNotification.isPermissionDialogOpen;
export const getIsReenablementDialogOpen = state => state.pushNotification.isReenablementDialogOpen;
export const getCampaignToSubscribe = state => state.pushNotification.campaignToSubscribe;

export const getRegistrationPossible = state => state.pushNotification.registrationPossible;
export const getIsOptedIn = state => state.pushNotification.isOptedIn;
export const getIsSupported = state => state.pushNotification.isSupported;
export const getPermissionStatus = state => state.pushNotification.permissionStatus;
export const getClientChannelId = state => state.pushNotification.clientChannelId;
export const getRegistrationErrors = state => state.pushNotification.registrationErrors;

export const getCampaignNotificationTags = state => state.pushNotification.campaignNotificationTags;
export const getCampaignNotificationTag = (campaignId) => state =>
    get(state, `pushNotification.campaignNotificationTags.${campaignId}.subscribed`, false);
export const getCampaignNotificationTagLoading = (campaignId) => state =>
    get(state, `pushNotification.campaignNotificationTags.${campaignId}.loading`, false);
